import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Typography, useMediaQuery, useTheme} from "@mui/material";
import {PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {StatsSectionData, SiteTemplate} from "../../types";
import {white} from "@/shared/colors";

export function StatsSection(props: { data: StatsSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  return <div style={{backgroundColor: theme.palette.primary.main}}>
    <SectionContainer>
      {props.data.title
        ? <StyledHeadingVariant default_={3} style={{color: white}}>
          {props.data.title}
        </StyledHeadingVariant>
        : null}
      <div style={{display: "flex", flexWrap: "wrap"}}>
        {props.data.stats.map((stat, i) =>
          <div key={i} style={{
            flex: "1 0 160px",
            minWidth: "40%",
            padding: sm ? PD_LG : PD_MD,
            borderLeft: i % 2 === 1 ? "1px solid rgba(255,255,255,0.2)" : "none",
          }}>
            <StyledBoxColumn style={{alignItems: "center", textAlign: "center", gap: PD_SM}}>
              <StyledHeadingVariant default_={2} style={{color: white, lineHeight: 1}}>
                {stat.value}
              </StyledHeadingVariant>
              <Typography style={{color: white, fontWeight: "700", opacity: 0.9}}>
                {stat.label}
              </Typography>
              {stat.description
                ? <Typography variant="body2" style={{color: white, opacity: 0.55}}>
                  {stat.description}
                </Typography>
                : null}
            </StyledBoxColumn>
          </div>
        )}
      </div>
    </SectionContainer>
  </div>;
}
